module.exports = __webpack_public_path__ + "static/media/external-link.5152545f.svg";